// Hook customizado para facilitar o acesso ao contexto de autenticação.
// Usado em vários arquivos como SignIn.tsx e SignUp.tsx para acessar os métodos signIn e signUp.

import { useContext } from 'react';
import JwtAuthContext from './JwtAuthContext';


//Utiliza useContext(JwtAuthContext), lançando erro se não estiver dentro do JwtAuthProvider.
const useJwtAuth = () => {
	const context = useContext(JwtAuthContext);
	if (!context) throw new Error('useJwtAuth must be used within JwtAuthProvider');
	return context;
};

export default useJwtAuth;
